import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import { InventariosTiposEditar, InventariosTiposGuardar, InventariosTiposListar } from '../../../../configuracion/apiUrls';
import { useEffect, useState } from "react"
import { regexNombre } from "../../../../configuracion/validaciones"; 
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";

const ModalInventarioTipo = ({ datos, token, setListaInventariosTipos, ActualizarLista }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [id, setId] = useState(datos ? datos.id : null);
    const [nombre, setNombre] = useState(datos ? datos.nombre : '');
    const [tipo, setTipo] = useState(datos ? datos.tipo : 'Bodega'); 
    const [estado, setEstado] = useState(datos ? datos.estado : 'Activo');
    const [errorNombre, setErrorNombre] = useState(false);

    useEffect(() => {
        if (regexNombre.test(nombre))
            setErrorNombre(false)
        else
            setErrorNombre(true)

    }, [nombre])

    useEffect(() => {
        if (modalIsOpen) {
            setNombre(datos ? datos.nombre : '');
            setTipo(datos ? datos.tipo : 'Bodega');
            setEstado(datos ? datos.estado : 'Activo');
            setId(datos ? datos.id : null)
        }
    }, [modalIsOpen])

    const BotonGuardar = () => {
        return (
            <button type="button" className="btn btn-success" onClick={guardarInventarioTipo}>Guardar</button>
        )
    }
    const BotonEditar = () => {
        return (
            <button type="button" className="btn btn-warning" onClick={editarInventarioTipo}>
                Editar
                <i className="fas fa-edit ml-2" />
            </button>
        )
    }
    const guardarInventarioTipo = () => {
        if (errorNombre) {
            mostraAlertaWarning("El nombre del tipo de inventario debe tener entre 3 y 100 caracteres y solo puede contener letras");
        } else if (!tipo) {
            mostraAlertaWarning("Debe seleccionar un tipo (Bodega o Móvil)");
        }
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.post(InventariosTiposGuardar, { nombre, tipo, estado })
                    .then((respuesta) => {
                        ActualizarLista(InventariosTiposListar, setListaInventariosTipos);
                        mostraAlertaOk("Registro guardado correctamente");
                        setModalIsOpen(false);
                    }).catch((er) => {
                        console.log(er);
                        ErroresPeticion(er);
                    })
            } catch (error) {
                mostraAlertaError("Error en la petición")
            }
        }

    }
    const editarInventarioTipo = () => {
        if (!id)
            mostraAlertaError("Seleccione un tipo de inventario");
        else if (errorNombre) {
            mostraAlertaWarning("El nombre del tipo de inventario debe tener entre 3 y 100 caracteres");
        } else if (!tipo) {
            mostraAlertaWarning("Debe seleccionar un tipo (Bodega o Móvil)");
        }
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.put(InventariosTiposEditar + id, { nombre, tipo, estado })
                    .then((respuesta) => {
                        ActualizarLista(InventariosTiposListar, setListaInventariosTipos);
                        mostraAlertaOk("Registro actualizado correctamente");
                        setModalIsOpen(false);
                    }).catch((er) => {
                        console.log(er);
                        ErroresPeticion(er);
                    })
            } catch (error) {
                mostraAlertaError("Error en la petición")
            }
        }

    }

    return (
        <ModalBootstrap
            titulo={datos ? "Editar Tipo de Inventario" : "Nuevo Tipo de Inventario"}
            nombreBoton={datos ? "" : "Nuevo Tipo de Inventario"}
            estiloBoton={datos ? "btn btn-outline-primary" : "btn btn-info"}
            iconBoton={datos ? "fas fa-edit mx-0" : "fas fa-box"}
            pie={datos ? <BotonEditar /> : <BotonGuardar />}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size={'sx'}
        >
            <div className="row">
                <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="nombre">Nombre</label>
                        <input
                            type="text"
                            className={`form-control ${errorNombre ? "is-invalid" : ""
                                }`}
                            id="nombre"
                            placeholder="Nombre"
                            name="nombre"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                        <span id="nombre-error" className="error invalid-feedback">
                            El nombre del tipo de inventario debe tener entre 3 y 100 caracteres y solo puede contener letras.
                        </span>

                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="tipo">Tipo</label>
                        <select
                            className="form-control"
                            id="tipo"
                            name="tipo"
                            value={tipo}
                            onChange={e => setTipo(e.target.value)}
                        >
                            <option value="Bodega">Bodega</option>
                            <option value="Movil">Móvil</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="estado">
                            Estado
                        </label>
                        <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customSwitch4" // Cambiado id para evitar duplicados
                                name="estado"
                                checked={estado == "Activo" ? true : false}
                                onChange={(event) => {
                                    setEstado(event.target.checked ? "Activo" : "Inactivo")
                                }}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="customSwitch4"
                            >
                                {estado}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBootstrap>
    );
}
export default ModalInventarioTipo;